import React, { useEffect, useState } from "react";
import { Popup } from "react-leaflet";
import 'bootstrap-icons/font/bootstrap-icons.css';

export default function MapPopup({ point }) {
    const p = point ?? {};
    const websiteRaw = (p.website ?? "").toString().trim();
    const facebookRaw = (p.facebook ?? "").toString().trim();
    const instagramRaw = (p.instagram ?? "").toString().trim();

    const [categoryEnumMap, setCategoryEnumMap] = useState({});
    /**
     * Return a normalized href for a given raw URL-like string.
     * If the string is empty returns null.
     */
    const makeHref = (raw) => {
        const s = (raw ?? "").toString().trim();
        return s ? (/^https?:\/\//i.test(s) ? s : `https://${s}`) : null;
    };
    const websiteHref = makeHref(websiteRaw);
    const facebookHref = makeHref(facebookRaw);
    const instagramHref = makeHref(instagramRaw);

    useEffect(() => {
        let cancelled = false;
        const apiBase = process.env.REACT_APP_SERVER_API_URL || "";
        const base = apiBase.replace(/\/$/, "");
        async function loadEnum() {
            try {
                const res = await fetch(`${base}/api/enums/CategoryTypeEnum`);
                if (!res.ok) return;
                const data = await res.json();
                if (cancelled) return;
                const map = (Array.isArray(data) ? data : []).reduce((m, it) => {
                    if (it && typeof it.value !== "undefined") m[String(it.value)] = it.display ?? String(it.value);
                    return m;
                }, {});
                console.log(map);
                setCategoryEnumMap(map);
            } catch {
                // ignore and keep map empty (will fallback to humanized names)
            }
        }
        loadEnum();
        return () => { cancelled = true; };
    }, []);

    const categoryTypes = p.categoryTypes && p.categoryTypes.length > 0
    //? p.categoryTypes.length == 1 ? p.categoryTypes : p.categoryTypes.join(", ")
        ? (() => {
            const mapped = p.categoryTypes.map(ct => {
                const key = String(ct);
                return typeof categoryEnumMap[key] !== "undefined" ? categoryEnumMap[key] : key;
            });
            return mapped.length === 1 ? mapped[0] : mapped.join(", ");
        })()
        : "";

    // Prevent the map from intercepting clicks/touches so links and router navigation work.
    const stopPropagation = (e) => {
        e.stopPropagation();
    };

    const renderRow = (label, value) => (
        <div className="row mb-1">
            <div className="col-5 sudHeader"><small>{label}</small></div>
            <div className="col-7 retailRegular">{value ?? "-"}</div>
        </div>
    );

    return (
        <Popup>
            <div className="mapPopup">
                <div className="row mb-2">
                    <div className="col-12">
                        {/*{p.id ? (*/}
                        {/*    <a*/}
                        {/*        href={`/manage/view/${encodeURIComponent(p.id)}`}*/}
                        {/*        target="_blank"*/}
                        {/*        rel="noopener noreferrer"*/}
                        {/*        className="link-primary popupHeader magnoHeader"*/}
                        {/*        onClick={stopPropagation}*/}
                        {/*        onMouseDown={stopPropagation}*/}
                        {/*        onMouseUp={stopPropagation}*/}
                        {/*        onTouchStart={stopPropagation}*/}
                        {/*        onAuxClick={stopPropagation}*/}
                        {/*        style={{ pointerEvents: "auto", textDecoration: "none" }}*/}
                        {/*    >*/}
                        {/*        <strong>{p.name ?? ``}</strong>*/}
                        {/*    </a>*/}
                        {/*) : (*/}
                        <strong className="magnoHeader">{p.name ?? ``}</strong>
                        {/*)}*/}
                    </div>
                </div>

                {/* social links row */}
                <div className="row mb-1 social-row">
                    <div className="col-12">
                        {facebookHref ? (
                            <a
                                href={facebookHref}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link-primary retailRegular social-link"
                                onClick={stopPropagation}
                                onMouseDown={stopPropagation}
                                onMouseUp={stopPropagation}
                                onTouchStart={stopPropagation}
                                onAuxClick={stopPropagation}
                                style={{ pointerEvents: "auto" }}
                            >
                                <i className="bi bi-facebook" aria-hidden="true" />
                            </a>
                        ) : "" }
                        {instagramHref ? (
                            <a
                                href={instagramHref}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link-primary retailRegular social-link"
                                onClick={stopPropagation}
                                onMouseDown={stopPropagation}
                                onMouseUp={stopPropagation}
                                onTouchStart={stopPropagation}
                                onAuxClick={stopPropagation}
                                style={{ pointerEvents: "auto" }}
                            >
                                <i className="bi bi-instagram" aria-hidden="true" />
                            </a>
                        ) : "" }
                    </div>
                </div>

                <div className="row mb-1">
                    <div className="col-5 sudHeader"><small>WEBSITE</small></div>
                    <div className="col-7">
                        {websiteHref ? (
                            <a
                                href={websiteHref}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link-primary retailRegular"
                                onClick={stopPropagation}
                                onMouseDown={stopPropagation}
                                onMouseUp={stopPropagation}
                                onTouchStart={stopPropagation}
                                onAuxClick={stopPropagation}
                                style={{ pointerEvents: "auto" }}
                            >
                                {websiteRaw}
                            </a>
                        ) : (
                            p.website ? p.website : "-"
                        )}
                    </div>
                </div>

                {renderRow("ADDRESS", p.civicAddress)}

                {renderRow("EMAIL", p.email)}
                {renderRow("PHONE", p.phone)}

                {renderRow("CATEGORY TYPE", categoryTypes)}

                {/* Render Hours of Operation with a dedicated class so we can force pre-wrap via CSS */}
                {/*<div className="row mb-1">*/}
                {/*    <div className="col-5 text-muted sudHeader"><small>Hours of Operation</small></div>*/}
                {/*    <div className="col-7 retailRegular hours-value">{p.hoursOfOperation ?? "-"}</div>*/}
                {/*</div>*/}
            </div>
        </Popup>
    );
}